export interface SectionPropsInterface {
  anchorId?: string
  mediaId?: number | string
  mediaSizes?: string
  background?: string
  gradient?: string
  paddingTop?: boolean
  paddingBottom?: boolean
  wave?: string
  waveMirrored?: boolean
  waveNegative?: boolean
  wavePaddingPercentage?: number | string
  loading?: boolean
}

const mediaSizeDefault = btoa('null');

export const SectionPropsDefaults: SectionPropsInterface = {
  mediaSizes: mediaSizeDefault,
  background: 'white',
  gradient: 'none',
  paddingTop: true,
  paddingBottom: true,
  wave: 'wave',
  wavePaddingPercentage: 0,
};
